import DataTable from "@shared/ui/data-table/DataTable";
import SearchTable from "@shared/ui/search-table/SearchTable";
import { Skeleton } from "@mui/material";
import { useTheme } from "@emotion/react";
import { StyledIncomes } from "./incomes.styled";
import { SEARCH_TABLE_STYLE } from "./incomes.constants";
import { useIncomeOptions } from "./incomes.data";
import { useIncomeStructures } from "./useIncomeStructures";
import { useIncomesBrowse } from "./useIncomesBrowse";
import { useIncomesNavigation } from "./useIncomesNavigation";

function Incomes() {
  const theme = useTheme();
  const { searchStructure, tableStructure } = useIncomeStructures();
  const browse = useIncomesBrowse();
  const navigation = useIncomesNavigation();
  const incomeOptions = useIncomeOptions();

  const skeletonSx = { bgcolor: theme.colors.section_color };

  return (
    <StyledIncomes>
      {searchStructure ? (
        <SearchTable
          structure={searchStructure}
          useForm={browse.accountSearchForm}
          setStructure={navigation.editSearchStructure}
          reset={browse.reset}
          style={SEARCH_TABLE_STYLE}
        />
      ) : (
        <Skeleton variant="rectangular" height={100} animation="wave" sx={skeletonSx} />
      )}
      {tableStructure ? (
        <DataTable
          structure={tableStructure}
          sortKey={browse.sortKey}
          setStructure={navigation.editBrowseStructure}
          setSortKey={browse.handleSortKeyChanged}
          sortMethod={browse.sortMethod}
          setSortMethod={browse.handleSortMethodChanged}
          data={browse.data}
          isLoading={browse.isLoading}
          options={incomeOptions}
        />
      ) : (
        <Skeleton variant="rectangular" height={150} animation="wave" sx={skeletonSx} />
      )}
    </StyledIncomes>
  );
}

export default Incomes;
